<template>
  <div class="p-d-flex p-jc-center centeredContainer whiteBg fullPage">
    <div v-if="!done">
      <div v-if="!token" class="p-fluid p-formgrid p-grid" style="max-width: 600px">
        <div class="p-field p-col-12">
          <a :href="`${landingPageURL}`">
            <img
              class="fullPageLogo"
              @click="refreshLeagueInformation"
              src="https://diamond-public.s3.us-west-2.amazonaws.com/assets/diamond-logo-white.png"
            />
          </a>
          <br />
          <h1 class="title is-2">{{ $t("request-password-reset") }}</h1>
          <p>{{ $t("please-enter-your-email-to-continue") }}</p>
        </div>
        <div class="p-field p-col-12">
          <label for="firstname6">{{ $t("Account.email") }}</label>
          <InputText
            id="firstname6"
            v-model="email"
            :placeholder="$t('e-g-hank-aaron-com')"
            type="email"
            autofocus="true"
          />
        </div>
        <div class="p-field p-col-12">
          <Button :disabled="!validEmail" @click="request" :label="$t('Button.continue')" />
        </div>
      </div>
      <div v-else-if="token" class="p-fluid p-formgrid p-grid" style="max-width: 600px">
        <div class="p-field p-col-12">
          <h1 class="title is-2">{{ $t("reset-password") }}</h1>
          <p>{{ $t("enter-a-new-password-8-characters-minimum") }}</p>
        </div>
        <div class="p-field p-col-12">
          <label for="firstname6">{{ $t("SignupWizard.password") }}</label>
          <InputText id="firstname6" v-model="password" :placeholder="$t('enter-a-password')" type="password" />
        </div>
        <div class="p-field p-col-12">
          <Button :disabled="password.length < 8" @click="update" :label="$t('Button.continue')" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  data() {
    return {
      done: false,
      email: "",
      password: "",
      error: "",
    };
  },
  computed: {
    token() {
      return this.getURLParam("token");
    },
    validEmail() {
      return this.validateEmail(this.email);
    },
  },
  methods: {
    request() {
      console.log("request " + this.email);
      api
        .forgotPassword(this.email)
        .then(() => {
          this.makeToast("success", this.$t("please-check-your-email-for-a-reset-link"));
          this.done = true;
          setTimeout(() => {
            this.goRouter("/sign-in");
          }, 2000);
        })
        .catch(e => {
          this.makeToast("success", this.$t("please-check-your-email-for-a-reset-link"));
          this.done = true;
        });
    },
    update() {
      console.log("update " + this.token);
      api
        .resetPassword(this.token, this.password)
        .then(() => {
          this.makeToast("success", this.$t("password-updated-please-login-to-continue"));
          this.done = true;
          setTimeout(() => {
            this.goRouter("/sign-in");
          }, 2000);
        })
        .catch(e => {
          this.makeToast("info", this.$t("unable-to-update-password"));
        });
    },
  },
  mounted() {
    window.analytics.page();
  },
};
</script>

<style scoped lang="scss">
form {
  margin-top: 1rem;
}
.error {
  text-align: center;
}
</style>
